<template>
  <div>
    <div class="historyBtnBox">
      <p class="showHistory" @click="showHistoryFn" v-show="localShowHistoryBtn">点击查看历史信息
        <van-loading v-show="loading" type="spinner" size="20px" color="#77797b"/>
      </p>
      <div class="cover" v-if="loading"></div>
    </div>
    <div v-if="showHistory">
      <div v-for="(item, index) in historyChat" :key="index">
        <div class="separateLineBox">
          <span class="historyText">{{ item.csdStartTime }}</span>
        </div>
        <div v-for="(i,num) in item.chatArr" :key="num">
          <!------------机器人对话框------------>
          <div class="chat-model" v-if="i.csdrUtype===0&&i.csdrType!==62&&item.csdrType!==63">
            <!--头像-->
            <div>
              <img :src="profilePhoto" alt="系统" class="headPortrait">
            </div>
            <!--对话-->
            <div class="chat-content chat-content-l">
              <div class="triangleLeft"></div>
              <!--消息内容-->
              <msgType :info="i"></msgType>
              <!--转人工-->
              <div v-if="i.csdrType===60||i.csdrType===61">
                <p>{{ i.csdrContent }}：
                  <span class='manualService'>
                  <van-icon name="phone" class="phone"/>转人工
                </span>
                </p>
              </div>
              <!--历史评价-->
              <div v-if="i.csdrType===51" class="evaluateMain">
                <!--                <van-rate-->
                <!--                  :readonly="i.evaluateReadonly"-->
                <!--                  v-model="i.csdrScore"-->
                <!--                  :size="25"-->
                <!--                  color="#ffd21e"-->
                <!--                  void-icon="star"-->
                <!--                  void-color="#eee"-->
                <!--                />-->
                <!--                <p class="evaluateContent">-->
                <!--                  <span v-show="i.csdrScore===1">非常不满意</span>-->
                <!--                  <span v-show="i.csdrScore===2">不满意</span>-->
                <!--                  <span v-show="i.csdrScore===3">一般</span>-->
                <!--                  <span v-show="i.csdrScore===4">满意</span>-->
                <!--                  <span v-show="i.csdrScore===5">非常满意</span>-->
                <!--                </p>-->
                <van-field
                  v-if="checkShowEvaluate(i)"
                  :readonly="i.evaluateReadonly"
                  v-model="i.csdrFeedbackContent"
                  :autosize="evaluateAutosize"
                  rows="1"
                  clearable
                  border
                  label-width="50"
                  label="反馈："
                  type="textarea"
                  placeholder="请输入您的反馈信息"
                />
                <van-button type="info" class="submitEvaluate" @click="submitEvaluateFn(i,index,num)"
                            v-if="!i.evaluateReadonly" size="small">提交
                </van-button>
              </div>
            </div>
          </div>
          <!--人工服务分界线-->
          <div class="personLine" v-if="i.csdrType===63">
            <div class="separateLineBox">
              <span class="historyText">{{i.csdrContent}}</span>
            </div>
          </div>
          <div class="personLine" v-if="i.csdrType===62">
            <div class="separateLineBox">
              <span class="historyText">人工服务中</span>
            </div>
          </div>
          <!------------客服对话框------------>
          <div class="chat-model" v-if="i.csdrUtype===2&&i.msgWithdrawStatus===0">
            <!--头像-->
            <div>
              <img src="../../assets/img/service.png" alt="客服" class="headPortrait">
            </div>
            <div class="chat-content chat-content-l">
              <div class="triangleLeft"></div>
              <!--消息内容-->
              <msgType :info="i"></msgType>
            </div>
          </div>
          <!--被撤回后展示的消息-->
          <div v-if="i.msgWithdrawStatus===1" class="withdrawMsgBox">
            <p>{{ i.msgWithdrawHint }}</p>
          </div>
          <!------------用户对话框------------>
          <div class="chat-model" style="justify-content: flex-end;" v-if="i.csdrUtype===1">
            <!--对话-->
            <div class="chat-content chat-content-r">
              <div class="triangle"></div>
              <!--消息内容-->
              <msgType :info="i"></msgType>
            </div>
            <!--头像-->
            <div>
              <img width="35px" height="35px" fit="fill" round src="../../assets/img/personal@3x.png" alt="用户"/>
            </div>
          </div>

        </div>
      </div>
      <!--分隔线-->
      <div class="separateLineBox">
        <span class="historyText">以上为历史消息</span>
      </div>
    </div>
  </div>
</template>

<script>
import {getChatHistory, submitEvaluate} from '../../service/getData'
import {ImagePreview, Toast} from 'vant'
import {getLoginInfo} from '../../util/auth'
import attachment from './attachment'
import msgType from './msgType'
import {formatDateTimeFn, ifOvertime} from '../../assets/js/common'

export default {
  name: 'historyChat',
  props: ['showHistoryBtn', 'currentDialogueNum', 'profilePhoto'],
  components: {attachment, msgType},
  data () {
    return {
      localShowHistoryBtn: this.showHistoryBtn, // 是否显示查看历史消息按钮
      pageNo: 0, // 查询历史记录，当前第几条，例如：1为倒数第一条，即最近的一条
      loginInfo: getLoginInfo(),
      loading: false,
      // 历史聊天
      historyChat: [],
      showHistory: false,
      evaluateAutosize: {
        maxHeight: 100,
        minHeight: 100
      }
    }
  },
  mounted () {
    document.body.addEventListener('click', this.clickOther)
  },
  beforeDestroy () {
    // 退出页面销毁addEventListener监听事件
    document.body.removeEventListener('click', this.clickOther)
  },
  methods: {
    // 监听全局是否有a标签跳转事件
    clickOther (event) {
      let target = event.target || event.srcElement // 兼容处理
      if (target.nodeName.toLocaleLowerCase() === 'a') { // 判断是否匹配目标元素
        if (event.preventDefault) { // 对捕获到的 a 标签进行处理
          event.preventDefault()
        } else {
          window.event.returnValue = true
        }
        // 处理完 a 标签的内容，重新触发跳转，根据原来 a 标签页 target 来判断是否需要新窗口打开
        let targetUrl = target.href
        if (targetUrl.indexOf('.pdf') === -1) {
          let pageHost = target.host
          if (pageHost === 'mp.weixin.qq.com') {
            // 微信公众号跳转页面
            window.open(targetUrl, '_blank')
          } else {
            // 其他链接跳转iframe
            this.$router.push({
              name: 'findExternallinks',
              query: {
                targetUrl: targetUrl
              }
            })
          }
        } else {
          let lastIndex = target.innerText.lastIndexOf('/')
          let fileInfo = {
            csdrAtt: target.href,
            csdrAttName: target.innerText.substring(lastIndex + 1)
          }
          this.$router.push({
            name: 'attachmentPreview',
            query: {
              file: JSON.stringify(fileInfo)
            }
          })
        }
      }
    },
    // 查看历史信息
    showHistoryFn () {
      let chatContent = document.getElementsByClassName('chatContentBox')[0]
      let lastScrollHeight = chatContent.scrollHeight
      this.loading = true
      this.pageNo += 1
      let params = {
        csdCode: this.currentDialogueNum,
        csdUid: this.loginInfo.uniqueCode,
        csdGroupCompanyCode: this.loginInfo.groupCompanyCode,
        pageNo: this.pageNo,
        pageSize: 1
      }
      getChatHistory(params).then(res => {
        if (res.code === 0) {
          if (res.data.list.length > 0) {
            // let chatArr = res.data.list[0].dialogueRecordList
            let chatArr = res.data.list[0].dialogueRecordList
            // 如果是普通文本，默认添加lineLimit参数，用来添加默认显示行数
            chatArr.forEach(item => {
              if (item.csdrType === 31) {
                item.lineLimit = 3
              }
              if (item.csdrType === 51) {
                if ((item.csdrFeedbackContent === null || item.csdrFeedbackContent === '' || item.csdrFeedbackContent === undefined) && !ifOvertime(item.csdrTime, 7)) {
                  // 没有评分，并且未超时，可以评价
                  item.evaluateReadonly = false
                } else {
                  // 有评分或者超时，不可以评价
                  item.evaluateReadonly = true
                }
              }
            })
            this.historyChat.unshift({
              csdStartTime: formatDateTimeFn(res.data.list[0].csdStartTime),
              chatArr
            })
            this.showHistory = true
            // 如果查询的是最后一条，隐藏查看历史按钮
            if (this.pageNo === res.data.total) {
              this.localShowHistoryBtn = false
            }
            this.$nextTick(() => {
              // 延迟获取当前高度，避免dom未加载完成
              setTimeout(() => {
                let scrollTop = chatContent.scrollHeight - lastScrollHeight
                chatContent.scrollTop = scrollTop
              }, 0)
            })
          } else {
            // 如果查询结果为空，隐藏查看历史按钮
            this.localShowHistoryBtn = false
          }
          this.loading = false
          this.$emit('findHistory', true)
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 查看当前聊天消息全部信息
    watchDetail (index, num) {
      console.log(index, num)
      this.historyChat[index][num].lineLimit = 'inherit'
    },
    // 查看大图
    showImg (img) {
      ImagePreview([img])
    },
    // 历史中转人工提示信息
    historyCall () {
      Toast.fail('操作已过期，请重新咨询')
    },
    // 提交评价
    submitEvaluateFn (item, index, num) {
      let ifPass = true
      if (item.csdrId === '' || item.csdrId === null || item.csdrId === undefined) {
        Toast.fail('缺少评价id')
        ifPass = false
      } else if (item.csdrFeedbackContent === '' || item.csdrFeedbackContent.match(/^\s+$/) || item.csdrFeedbackContent === null || item.csdrFeedbackContent === undefined) {
        Toast.fail('请填写评价内容')
        ifPass = false
      }

      if (ifPass) {
        item.feedbackScore = item.csdrScore
        item.feedbackContent = item.csdrFeedbackContent
        let params = {...item}
        submitEvaluate(params).then(res => {
          if (res.code === 0) {
            // 禁止评价
            this.historyChat[index]['chatArr'][num]['evaluateReadonly'] = true
          } else {
            Toast.fail(res.msg)
          }
        })
      }
    },
    // 检查是否需要显示评论
    checkShowEvaluate (i) {
      // 情况1：已有评论，已提交
      let condition1 = i.csdrFeedbackContent !== null && i.csdrFeedbackContent !== '' && i.evaluateReadonly
      // 情况2：已评分，无评论，且没提交
      let condition2 = (i.csdrScore !== 0 && i.csdrScore !== null && i.csdrScore !== '') && (i.csdrFeedbackContent === null || i.csdrFeedbackContent === '') && !i.evaluateReadonly
      // 情况3：已评分，有评论，且没提交
      let condition3 = (i.csdrScore !== 0 && i.csdrScore !== null && i.csdrScore !== '') && (i.csdrFeedbackContent !== null || i.csdrFeedbackContent !== '') && !i.evaluateReadonly
      // 情况4：无评分
      let condition4 = i.csdrScore === null || i.csdrScore === '' || i.csdrScore === 0

      if (condition1 || condition2 || condition3 || condition4) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    showHistoryBtn: {
      handler (newValue, oldValue) {
        this.localShowHistoryBtn = newValue
        this.$forceUpdate()
      },
      immediate: true,
      deep: true
    },
    currentDialogueNum: {
      handler (newValue, oldValue) {
        this.$forceUpdate()
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped>
.chat {
  width: 100%;
  height: 100vh;
  background-color: #f2f3f5;
  overflow: hidden;
  font-size: 15px;
}

.topNav {
  position: relative;
  background: #fff;
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.chatContentBox {
  background-color: #f2f3f5;
  width: 100%;
  height: calc(100vh - 110px);
  padding-bottom: 10px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.guideBox {
  display: flex;
  flex-direction: row;
  background-color: #f2f3f5;
  border-radius: 5px;
  max-width: 90%;
  word-break: break-all;
  word-wrap: break-word;
  /* top: 18px; */
  padding: 10px;
  border-radius: 5px;
}

.guideBoxContent {
  position: relative;
  word-break: break-all;
  word-wrap: break-word;
  /* top: 18px; */
  padding: 10px;
  padding-bottom: 0;
  border-radius: 5px;
  background-color: white;
  margin-left: 15px;
}

.guideLi {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid rgb(201, 196, 196);
  color: #1989fa;
}

ul .guideLi:last-child {
  border-bottom: none;
}

.chat-model {
  display: flex;
  flex-direction: row;
  margin: 10px 10px;
  margin-top: 20px;
}

.chat-content {
  position: relative;
  max-width: 69%;
  word-break: break-all;
  word-wrap: break-word;
  /* top: 18px; */
  padding: 10px;
  border-radius: 5px;
}

.chat-content-r {
  background: #448af7;
  color: #fff;
  margin-right: 15px;
}

.chat-content-l {
  background-color: white;
  margin-left: 15px;
}

.triangle {
  position: absolute;
  right: 10px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #448af7;
  right: -16px;
  top: 8px;
}

.triangleLeft {
  position: absolute;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-right: 10px solid white;
  border-bottom: 10px solid transparent;
  border-left: 10px solid transparent;
  left: -16px;
  top: 8px;
}

.input-container {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px 0px;
}

.inputBox {
  width: 80%;
  height: 35px;
  border-radius: 20px;
  border: 1px solid #adacac;
  padding-left: 10px;
  margin-right: 5px;
}

.sendImg {
  vertical-align: middle;
}

.evaluateBox {
  font-size: 12px;
  margin-top: 15px;
  margin-left: 16%;
  max-width: 69%;
  height: 35px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.goodBox {
  display: inline-block;
  width: 20%;
}

.noGoodBox {
  display: inline-block;
  width: 20%;
}

.manualService a {
  color: #448af7;
  margin-right: 10px;
  position: absolute;
  right: 0;
}

.historyBtnBox {
  margin: 20px 0;
  position: relative;
}

.showHistory {
  color: dodgerblue;
  text-align: center;
}

.cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.imgMsg {
  width: 150px;
}

.van-loading {
  display: inline-block;
  text-align: center;
  margin-left: 5px;
  vertical-align: bottom;
}

.separateLineBox {
  height: 0px;
  border: 0.5px dashed #c1bfbf;
  margin: 30px auto;
  width: 90%;
  text-align: center;
}

.historyText {
  font-size: 14px;
  color: #c1bfbf;
  background: #f2f3f5;
  padding:0 5px;
  text-align: center;
  position: relative;
  bottom: 10px;
}

.watchDetail {
  color: #448af7;
  font-size: 14px;
}

.talkMsg {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
}

.fileBox {
  width: 150px;
  height: 40px;
  display: flex;
}

.fileIcon {
  width: 34px;
  margin-left: auto;
}

.fileSize {
  color: #adacac;
  font-size: 12px;
}

.headPortrait {
  width: 35px;
  height: 35px;
}

.call {
  color: gray;
}

.phone {
  width: 22px;
  vertical-align: middle;
  filter: grayscale(1);
}

.van-rate {
  width: 80%;
  display: flex;
  justify-content: space-around;
  margin: 0 auto;
}

.evaluateMain {
  width: 250px;
  padding-top: 0px;
  margin-top: 10px;
}

/deep/ .evaluateMain .van-cell {
  padding: 0;
}

/deep/ .evaluateMain .van-field__label {
  margin-right: 0;
}

.evaluateContent {
  text-align: center;
  color: red;
  font-size: 16px;
  font-weight: bold;
  margin: 15px 0;
}

.submitEvaluate {
  width: 100%;
  margin-top: 10px;
}

.personLine {
  color: #adacac;
  text-align: center;
  font-size: 14px;
}

.withdrawMsgBox {
  text-align: center;
  margin: 20px 0;
  font-size: 12px;
  color: #a9a5a5;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/historyChat.vue